import React, { useEffect, useLayoutEffect, useState } from "react";
import {
  Dialog,
  DialogActions,
  DialogContent,
  Typography,
  Box,
  IconButton,
  Button,
  TextField,
} from "@mui/material";
import { makeStyles } from "@mui/styles";
import "../../../Sass/Common.scss";

import { ReactComponent as RepeatSmart } from "Assets/Logo/RepeatSmart.svg";
import { ReactComponent as CloseIcon } from "../../../Assets/Icons/CloseIcon.svg";
import { connect } from "react-redux";
import { useSelector } from "react-redux";
import { START_PAYMENT_LINK } from "../../../Actions/HomeAction";
import { START_GET_LOGIN_USER } from "../../../Actions/UserAction";
import PrimaryIcon from "../PrimaryIcon";
const useStyle = makeStyles((theme) => ({
  dialogMain: {
    "& .MuiPaper-root.MuiPaper-elevation": {
      position: "absolute",
      //   top: "0 !important",
    },
    "& .MuiDialogTitle-root": {
      borderBottom: "none",
      "&>p": {
        "&>svg": {
          position: "relative",
          top: "18px",
          right: "28px",
        },
      },
    },
  },
  rsNoteGrid: {
    "& .MuiTableBody-root": {
      "&>tr": {
        "&>td": {
          padding: "12px 17px !important",
        },
      },
    },
  },
  rsBillingSubtitle: {
    fontSize: "16px !important",
    fontWeight: "300 !important",
    textAlign: "center",
    color: "black  !important",
    marginTop: "20px",
    paddingRight: "5px",
  },

  rsSubtitle: {
    display: "grid",
    textAlign: "center",
    width: "100%",
    justifyContent: "center",
    "&>button": {
      marginBottom: "20px",
    },
  },

  rsWarning: {
    marginTop: "50px",
    width: "290px",
  },
  rsWarningSubscription: {
    width: "92%",
    whiteSpace: "nowrap",
    marginTop: "50px",
    fontSize: "20px !important",
    fontWeight: "500 !important",
  },
  CloseIcon: {
    position: "absolute !important",
    top: "20px",
    right: "20px",
  },
  rsMain: {
    display: "inline-grid",
    textAlign: "center",
    justifyContent: "center",
    justifyItems: "center",
  },
  rscopyButton: {
    display: "flex",
    marginBottom: "50px",
    "&>button": {
      marginLeft: "-10px",
    },
  },
}));
const CopyButton = ({ inputId, copiedInputId, setCopiedInputId }) => {
  function handleCopy(inputId) {
    let textarea = document.getElementById(inputId);
    textarea.select();
    document.execCommand("copy");
    setCopiedInputId(inputId);
  }

  return (
    <Button variant="contained" onClick={() => handleCopy(inputId)}>
      {copiedInputId === inputId ? "Copied" : "Copy"}
    </Button>
  );
};
const DisplayLinkDialog = (props) => {
  const classes = useStyle();
  const { open, setOpen, paymentStripLink } = props;
  const loginUserDetail = useSelector((state) => state.user);
  const [copiedInputId, setCopiedInputId] = useState("");
  /**handle close dialog */

  const handleClose = () => {
    setOpen(false);
  };

  return (
    <>
      <Dialog
        open={open}
        maxWidth={"sm"}
        onClose={(e) => {
          if (e.key === "Escape") {
            handleClose();
          }
        }}
        className={classes.dialogMain}
        BackdropProps={{
          classes: {
            root: "root",
          },
        }}
      >
        <IconButton className={classes.CloseIcon} onClick={() => handleClose()}>
          {" "}
          <PrimaryIcon icon={CloseIcon} />{" "}
        </IconButton>
        <Box className={classes.rsMain}>
          <Box className={classes.rsWarningSubscription}>
            Copy and share your link{" "}
          </Box>
        </Box>

        <Box className={classes.rsNoteGrid}>
          <DialogContent>
            <Box className={classes.rscopyButton}>
              <TextField
                variant="outlined"
                fullWidth
                size="small"
                name="name"
                id="email"
                value={paymentStripLink}
              />
              <CopyButton
                inputId={"email"}
                copiedInputId={copiedInputId}
                setCopiedInputId={setCopiedInputId}
              />
              {}
            </Box>
          </DialogContent>
        </Box>
      </Dialog>
    </>
  );
};

const mapStateToProps = (state) => ({
  paymentCreate: state.home.paymentCreate,
  paymentLink: state.home.paymentLink,
});
const mapDispatchToProps = (dispatch) => ({
  paymentLinkAction: (payload) =>
    dispatch({ type: START_PAYMENT_LINK, payload }),
  getLoginUserAction: () => dispatch({ type: START_GET_LOGIN_USER }),
});
export default connect(mapStateToProps, mapDispatchToProps)(DisplayLinkDialog);
